import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { useAppSelector } from "integrations/redux/hooks"
import useSWR from "swr"
import { ActivatablePluginName, useRunScopedSearch, useRunSearch } from "./registry"

export function useSearchResults(query: string, options?: { enabled?: boolean }) {
    const enabled = options?.enabled ?? true
    const orgId = useAppSelector(selectActiveWorkspaceId())
    const runSearch = useRunSearch()
    const swr = useSWR(
        query && enabled ? ["overview-search", query, orgId, runSearch] : null,
        () => runSearch(query, { orgId }),
        { revalidateOnFocus: false }
    )
    return { results: swr.data ?? [], isLoading: swr.isLoading }
}

export function useScopedSearchResults(
    pluginName: ActivatablePluginName | undefined,
    query: string
) {
    const orgId = useAppSelector(selectActiveWorkspaceId())
    const runScopedSearch = useRunScopedSearch()
    const swr = useSWR(
        ["overview-search-scoped", pluginName, query, orgId, runScopedSearch],
        () => (pluginName ? runScopedSearch(pluginName, query, { orgId }) : []),
        { revalidateOnFocus: false }
    )
    return { results: swr.data ?? [], isLoading: swr.isLoading }
}
